import {ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation} from '@angular/core';
import {Breadcrumb} from 'src/app/types/Breadcrumb';
import {RoutesNamesEnum} from 'src/app/enums/RoutesEnums';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
  public breadcrumbs = input<Breadcrumb[]>(null);

  public breadcrumbsToDisplay = computed<Breadcrumb[]>(() => {
    const crumbs = this.breadcrumbs() || [];
    const needsHome = crumbs.length === 0 || crumbs[0]?.anchor !== RoutesNamesEnum.HOME;

    return needsHome
      ? [{routeParams: ['/'], routeQueryParams: null, anchor: RoutesNamesEnum.HOME}, ...crumbs]
      : [...crumbs];
  });
}
